// extracted by mini-css-extract-plugin
module.exports = {"whiteButton":"src-components-UI-Buttons-WhiteButton-styles-style-module__whiteButton--3khsL","label":"src-components-UI-Buttons-WhiteButton-styles-style-module__label--1EuCH"};